module.exports = __webpack_public_path__ + "static/img/RU.79621d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/userTips/RU.png
// module id = snQm
// module chunks = 1